import { Grid, Typography, TableCell } from '@mui/material';
import React from 'react';

const SettingsTableCells = ({ content, weight, ...props }) => {
  return (
    <TableCell {...props}>
      <Grid container wrap='nowrap'>
        <Typography
          variant='h4'
          sx={{
            fontWeight: weight,
            whiteSpace: 'wrap',
          }}
        >
          {content}
        </Typography>
      </Grid>
    </TableCell>
  );
};

export default SettingsTableCells;
